/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  SiloSnapshotWrapper,
  SiloSnapshotWrapperInterface,
} from "../SiloSnapshotWrapper";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_siloToken",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "_vestingContracts",
        type: "address[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "getCurrentBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "getVestingBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "userBalance",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "siloToken",
    outputs: [
      {
        internalType: "contract ERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "vestingContracts",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type SiloSnapshotWrapperConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: SiloSnapshotWrapperConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class SiloSnapshotWrapper__factory extends ContractFactory {
  constructor(...args: SiloSnapshotWrapperConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "SiloSnapshotWrapper";
  }

  deploy(
    _siloToken: string,
    _vestingContracts: string[],
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<SiloSnapshotWrapper> {
    return super.deploy(
      _siloToken,
      _vestingContracts,
      overrides || {}
    ) as Promise<SiloSnapshotWrapper>;
  }
  getDeployTransaction(
    _siloToken: string,
    _vestingContracts: string[],
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _siloToken,
      _vestingContracts,
      overrides || {}
    );
  }
  attach(address: string): SiloSnapshotWrapper {
    return super.attach(address) as SiloSnapshotWrapper;
  }
  connect(signer: Signer): SiloSnapshotWrapper__factory {
    return super.connect(signer) as SiloSnapshotWrapper__factory;
  }
  static readonly contractName: "SiloSnapshotWrapper";
  public readonly contractName: "SiloSnapshotWrapper";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SiloSnapshotWrapperInterface {
    return new utils.Interface(_abi) as SiloSnapshotWrapperInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): SiloSnapshotWrapper {
    return new Contract(address, _abi, signerOrProvider) as SiloSnapshotWrapper;
  }
}
